import { AccountingDynamicBulkUploadModule } from './../shared/controls/dynamic/accounting-dynamic-bulk-upload.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { InvoicesComponent } from './invoices.component';
import { AuthGuard } from '../../services/auth-guard.service';
import { DynamicFormModule } from '../shared/controls/dynamic/dynamic-form.component';
import { LoadingModule } from '../shared/controls/loading.component';
import { NotesModule } from '../shared/controls/notes.component';
import { LastUpdatedModule } from '../shared/controls/last-updated.component';

import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InvoiceListComponent } from './invoice-list.component';
import { SortIconCustomModule } from '../shared/controls/dynamic/sort-icon-custom.component';
import { DynamicValueModule } from '../shared/controls/dynamic/dynamic-value.component';
import { InvoiceDetailComponent } from './invoice-detail.component';
import { VehiclesDetailModule } from '../shared/controls/vehicles-detail.component';
import { PaginatorCustomModule } from '../shared/controls/dynamic/paginator-custom.component';
import { SimpleControlModule } from '../shared/controls/dynamic/simple-control.component';
import { CheckboxModule } from 'primeng/checkbox';
import { UserFormModule } from '../users/user-form.component';
import { OrderFormModule } from '../orders/order-form.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { RowToolsModule } from '../shared/controls/row-tools.component';
import { OrderTagsModule } from '../orders/order-tags.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { UploadsModule } from '../shared/controls/uploads.component';
import { InvoiceFormModule } from './invoice-form.component';
import { LocationFormModule } from '../locations/location-form.component';
import { ContactsDetailModule } from '../shared/controls/contacts-detail.component';
import { NotesDetailModule } from '../shared/controls/notes-detail.component';
import {TooltipModule} from 'primeng/tooltip';
@NgModule({
  declarations: [
    InvoicesComponent,
    InvoiceListComponent,
    InvoiceDetailComponent,
  ],
  imports: [
    CommonModule,
    TableModule,
    NotesModule,
    DialogModule,
    UploadsModule,
    InvoiceFormModule,
    LoadingModule,
    ButtonModule,
    LastUpdatedModule,
    SortIconCustomModule,
    DynamicValueModule,
    VehiclesDetailModule,
    PaginatorCustomModule,
    CheckboxModule,
    UserFormModule,
    OrderFormModule,
    OrderTagsModule,
    RowToolsModule,
    LocationFormModule,
    ContactsDetailModule,
    NotesDetailModule,
    TooltipModule,
    AccountingDynamicBulkUploadModule,
    RouterModule.forChild([
      {
        path: '',
        component: InvoicesComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'active', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'complete', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'account_payable', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'ach', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'ach_documents_required', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'ach_ready_to_pay', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'ach_ready_to_pay_over_the_next_week', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'ach_pay_today', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'mail', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'mail_documents_required', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'mail_ready_to_pay', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'mail_ready_to_pay_over_the_next_week', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'mail_pay_today', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'carrier_payments_on_hold', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'account_receivable', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'invoice_needs_to_be_sent', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'customer_billing', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'late_customer_payment', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'carrier_billing', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'late_carrier_payment', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'commission_info_required', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'invoice_totalcost_null', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'ready_to_audit', component: InvoiceListComponent, canActivate: [AuthGuard] },
          { path: 'invoices_with_issues', component: InvoiceListComponent, canActivate: [AuthGuard] },
        ]
      }
    ])
  ],
  exports: [
    InvoicesComponent,
    InvoiceListComponent,
    InvoiceDetailComponent,
  ]
})
export class InvoicesModule { }

